import { useMemo } from 'react';
//schemas
import { VacancyFragments$data } from 'schemas/vacancy/__generated__/VacancyFragments.graphql';

export function useFoundInvite(vacancy: VacancyFragments$data, crewProfileId: string) {
  return useMemo(() => {
    return vacancy.invites?.find(invite => invite.owner?.id === crewProfileId);
  }, [vacancy.invites, crewProfileId]);
}
